import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../css/AdminDashboard.css";
import { getUser } from "../services/user-service";
import {
  getAllEmployees,
  assignTicketToEmployee,
} from "../services/AdminService";
import { getToken } from "../services/user-service";
import { getRegisteredContactRequests, getFile,getUnregisteredContactRequests,getAllContactRequests,updateRequestStatus  ,getRequestCountByStatus ,getTicketMessages, sendTicketMessage} from "../services/supportService";
import AdminNavbar from "../components/AdminNavbar"; 
import { Notification } from "../components/alerting-visitors/notification";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Button,
  Typography,
  Modal,
  Box,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AdminDashboard = () => {
  const [contactRequests, setContactRequests] = useState([]);
  const [showTickets, setShowTickets] = useState(false);
  const [selectedTab, setSelectedTab] = useState("registered");
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageHistory, setMessageHistory] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [selectedTicketId, setSelectedTicketId] = useState(null);
const [loading, setLoading] = useState(false);
const user = getUser();
  const navigate = useNavigate();

  const [counts, setCounts] = useState({
    OPEN: 0,
    IN_PROGRESS: 0,
    REOPEN: 0,
    SOLVED: 0,
    CLOSED: 0,
  });
  const getCurrentDateTime = () => {
    const now = new Date();
    return {
      date: now.toLocaleDateString(),
      time: now.toLocaleTimeString(),
    };
  };
  const [selectedContact, setSelectedContact] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  
  const handleViewTicketDetails = (contact) => {
    setSelectedContact(contact);
    setShowDetailsModal(true);
  };
  
  const normalizeStatus = (status) => {
    return status?.toLowerCase().replace(/[_\s]/g, '-');
    };
  const downloadFile = async (ticketId, fileName) => {
  try {
    const response = await getFile(ticketId,fileName);
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = fileName || 'attachment';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
  const [currDateTime, setCurrDateTime] = useState(getCurrentDateTime());
  const [showCloseModal, setShowCloseModal] = useState(false); 
  const [closeMessage, setCloseMessage] = useState(""); 
  const [selectedContactId, setSelectedContactId] = useState(null); 
  const handleOpenMessages = async (ticketId) => {
    try {
      const messages = await getTicketMessages(ticketId);
      setMessageHistory(messages);
      setSelectedTicketId(ticketId);
      setShowMessageModal(true);
    } catch (error) {
      toast.error("Failed to load messages.");
    }
  };
  const handleSendMessage = async () => {
    if (!newMessage.trim()) return;
  
    const optimisticMessage  = {
      sender: "ADMIN",
      content: newMessage,
      timestamp: new Date().toISOString(),
      temp: true, 
    };
  
    setMessageHistory((prev) => [...prev, optimisticMessage]);

  const messageToSend = newMessage;
  setNewMessage("");
  
    try {
      await sendTicketMessage(selectedTicketId, {
        sender: "ADMIN",
        content: messageToSend,
      });
  
      } catch (error) {
      toast.error("Failed to send message. Please try again.");
    }
  };
  
  useEffect(() => {
    
    const interval = setInterval(() => {
      setCurrDateTime(getCurrentDateTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const fetchCounts = async () => {
    try {
      const open = await getRequestCountByStatus("open");
      const in_Progress = await getRequestCountByStatus("in_Progress");
      const reopen = await getRequestCountByStatus("reopen");
      const solved = await getRequestCountByStatus("solved");
      const closed = await getRequestCountByStatus("closed");
  
      setCounts({
        OPEN: open,
        IN_PROGRESS: in_Progress,
        REOPEN: reopen,
        SOLVED: solved,
        CLOSED: closed,
      });
    } catch (error) {
      toast.error("Error fetching status counts");
    }
  };
  
  useEffect(() => {
    fetchCounts();
  }, []);
const fetchRegisteredRequests = async () => {
  try {
    const data = await getRegisteredContactRequests();
    setContactRequests(data);
  } catch (error) {
    toast.error("Error fetching registered contact requests");
  }
};
const [assignModalOpen, setAssignModalOpen] = useState(false);
const [selectedTicket, setSelectedTicket] = useState(null);
const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
const [employeeList, setEmployeeList] = useState([]);
  const token = getToken();

const loadEmployees = async () => {
  try {
    const data = await getAllEmployees(token);
    setEmployeeList(data); 
  } catch (err) {
    console.error(err);
  }
};
const handleAssignClick = (ticket) => {
  setSelectedTicket(ticket);
  loadEmployees();
  setAssignModalOpen(true);
};
const refreshTickets = () => {
  if (selectedTab === "registered") {
    fetchRegisteredRequests();
  } else {
    fetchUnregisteredRequests();
  }
};


const handleAssignSubmit = async () => {
  try {
    await assignTicketToEmployee(selectedTicket.id, selectedEmployeeId, token);
    toast.success("Assigned successfully");
    setAssignModalOpen(false);
    refreshTickets();
  } catch (err) {
    toast.error("Assignment failed");
  }
};

  const [selectedStatus, setSelectedStatus] = useState(null);

const filteredData = (contactRequests || []).filter(item => {
  const statusMatch = selectedStatus ? normalizeStatus(item.status) === normalizeStatus(selectedStatus) : true;
  return statusMatch;
});
{filteredData.map((contact) => (
  <div key={contact.id} className="ticket-card">
    {/* Render ticket info here */}
    <p>{contact.subject}</p>
    <p>Status: {contact.status}</p>
    <button onClick={() => handleViewTicketDetails(contact)}>View</button>
  </div>
))}

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
  };
  const fetchUnregisteredRequests = async () => {
    try {
      const data  = await getUnregisteredContactRequests();
      setContactRequests(data);
    } catch (error) {
      toast.error("Error fetching unregistered contact requests");
    }
  };
 useEffect(() => {
  if (selectedTab === "registered") {
    fetchRegisteredRequests();
  } else {
    fetchUnregisteredRequests();
  }
}, [selectedTab]);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
  const greeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };
  if (!user) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '40vh',
      textAlign: 'center'
    }}>
      <h1>Session expired. Login again</h1>
    </div>
  );
}

  
  return (
    <>
    <AdminNavbar />    
          <div style={{ marginTop: "4rem" }}></div>  
          <div style={{ backgroundColor: "yellow", padding: "3px 0 6px 0" }}>
          <Notification />
          </div>
          <div className="main1" style={{ textAlign: "center" }}>
        <div className="Dashboard_main1">
          <div className="dashboard_left1">
            <div className="user_details_dash1">
              <div className="UserDetails1">
                <p className="Username_details1">
                  {greeting()},{" " + user.firstName}
                  <br />
                  Welcome to I
                  <span style={{ color: "#059212" }}>-</span>Chest Admin Panel
                </p>
                <p className="date_time_details1">
                  Today {currDateTime.date} {currDateTime.time}
                </p>
              </div>

              <div className="User_action_btns1">
                <div className="user_dashbord_btn1">
                  <div
                    className="dashboard_action_btn1 open_tab"
                    onClick={() => handleStatusChange('OPEN')}
                  >
                    OPEN ({counts.OPEN})
                  </div>
                  <div
                    className="dashboard_action_btn1 pending_tab"
                    onClick={() => handleStatusChange('IN_PROGRESS')}
                  >
                    IN PROGRESS ({counts.IN_PROGRESS})
                  </div>
                  <div
                    className="dashboard_action_btn1 reopened_tab"
                    onClick={() => handleStatusChange('REOPEN')}
                  >
                    REOPEN ({counts.REOPEN})
                  </div>
                  <div
                    className="dashboard_action_btn1 rejected_tab"
                    onClick={() => handleStatusChange('SOLVED')}
                  >
                    SOLVED ({counts.SOLVED})
                  </div>
                  <div
                    className="dashboard_action_btn1 closed_tab"
                    onClick={() => handleStatusChange('CLOSED')}
                  >
                    CLOSED ({counts.CLOSED})
                  </div>
                </div>
              </div>

            </div>
            <div className="tickets_wrapper">
            <div className="tab_selector">
              <select
                value={selectedTab}
                onChange={(e) => handleTabChange(e.target.value)}
                className="dropdown_select"
              >
                <option value="registered">Registered User</option>
                <option value="unregistered">UnRegistered User</option>
              </select>
            </div>


            {selectedTab === "registered" && (
                <div className="scrollable-ticket-section">
              <div className="propCard1">
                <div className="propCard-card1">
                  {filteredData.map((contact) => (
                    <div className="propCard-card-body" key={contact.id}>
                      <div className="propCard_card_status">
                           <p className="propCard-card-text">
                              ID: <strong>{contact.id}</strong>
                            </p>
                        <p className={`propCard_card_status_text ${normalizeStatus(contact.status)}`}>
                          {(() => {
                            const labelMap = {
                              'in-progress': 'In Progress',
                              'solved': 'Solved',
                              'open': 'Open',
                              'reopen': 'Reopen',
                              'closed': 'Closed',
                            };
                            const normalized = normalizeStatus(contact.status);
                            return labelMap[normalized] || normalized;
                          })()}
                        </p>
                      </div>

                      <div className="propCard-card-title">
                        <h5 className="card_subject">{contact.subject}</h5>
                      </div>

                      <p className="propCard-card-text">
                        Submitted on: {new Date(contact.createdDate).toLocaleString()}
                      </p>

                       <p className="propCard-card-text">
                          Assigned to: <strong>
                            {contact.assignedEmployeeFirstName
                              ? `${contact.assignedEmployeeFirstName} ${contact.assignedEmployeeLastName}`
                              : "Not Assigned"}
                          </strong>                        
                          </p>

                        <div className="propCard-btn" style={{ display: "flex", gap: "10px" }}>
                          <button onClick={() => handleViewTicketDetails(contact)}>
                            Info
                          </button>
                          <button
                            className="assign-button"
                            onClick={() => handleAssignClick(contact)}
                            disabled={!!contact.assignedEmployeeFirstName}  
                            style={{
                              cursor: contact.assignedEmployeeFirstName ? "not-allowed" : "pointer",
                              opacity: contact.assignedEmployeeFirstName ? 0.6 : 1,
                            }}
                          >
                            Assign
                          </button>
                        </div>
                    </div>
                  ))}
                </div>
                </div>
              </div>
            )}

            {selectedTab === "unregistered" && (
                  <div className="scrollable-ticket-section">
              <div className="propCard1">
                <div className="propCard-card1">
                  {filteredData.map((contact) => (
                    <div className="propCard-card-body" key={contact.id}>
                      <div className="propCard_card_status">
                        <p className="propCard-card-text">
                              ID: <strong>{contact.id}</strong>
                            </p>
                        <p className={`propCard_card_status_text ${normalizeStatus(contact.status)}`}>
                          {(() => {
                            const labelMap = {
                              'in-progress': 'In Progress',
                              'solved': 'Solved',
                              'open': 'Open',
                              'closed': 'Closed',
                            };
                            const normalized = normalizeStatus(contact.status);
                            return labelMap[normalized] || normalized;
                          })()}
                        </p>
                      </div>

                      <div className="propCard-card-title">
                        <h5 className="card_subject">{contact.subject}</h5>
                      </div>

                      <p className="propCard-card-text">
                        Submitted on: {new Date(contact.createdDate).toLocaleString()}
                      </p>

                      <p className="propCard-card-text">
                        Assigned to: <strong>
                          {contact.assignedEmployeeFirstName
                            ? `${contact.assignedEmployeeFirstName} ${contact.assignedEmployeeLastName}`
                            : "Not Assigned"}
                        </strong>                      
                        </p>

                      <div className="propCard-btn" style={{ display: "flex", gap: "10px" }}>
                        <button onClick={() => handleViewTicketDetails(contact)}>
                          Info
                        </button>
                         <button
                            className="assign-button"
                            onClick={() => handleAssignClick(contact)}
                            disabled={!!contact.assignedEmployeeFirstName}  
                            style={{
                              cursor: contact.assignedEmployeeFirstName ? "not-allowed" : "pointer",
                              opacity: contact.assignedEmployeeFirstName ? 0.6 : 1,
                            }}
                          >
                            Assign
                          </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            )}

            </div>
          </div>
        </div>
      </div>
      <Dialog open={showCloseModal} onClose={() => setShowCloseModal(false)} fullWidth maxWidth="sm">
  <DialogTitle>
    Close Request
    <IconButton
      aria-label="close"
      onClick={() => setShowCloseModal(false)}
      sx={{ position: 'absolute', right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers>
    <TextField
      fullWidth
      multiline
      rows={4}
      variant="outlined"
      label="Closing Message"
      placeholder="Enter your closing message..."
      value={closeMessage}
      onChange={(e) => setCloseMessage(e.target.value)}
    />
  </DialogContent>
  <DialogActions>
    <Button
      variant="contained"
      color="primary"
      onClick={async () => {
        if (!closeMessage.trim()) {
          toast.warning("Please enter a message.");
          return;
        }

        try {
          await updateRequestStatus(selectedContactId, "CLOSED", closeMessage);
          toast.success("Request closed with message");
          setShowCloseModal(false);
          setCloseMessage("");
          let updatedRequests;
          if (selectedTab === "registered") {
            updatedRequests = await getRegisteredContactRequests();
          } else {
            updatedRequests = await getUnregisteredContactRequests();
          }
          setContactRequests(updatedRequests);
          setContactRequests(updatedRequests);
          fetchCounts();
        } catch (err) {
          toast.error("Failed to close request");
        }
      }}
    >
      Submit
    </Button>
    <Button
      variant="outlined"
      onClick={() => {
        setShowCloseModal(false);
        setCloseMessage("");
      }}
    >
      Cancel
    </Button>
  </DialogActions>
</Dialog>
  <Dialog open={assignModalOpen} onClose={() => setAssignModalOpen(false)} fullWidth maxWidth="sm">
  <DialogTitle>Assign Ticket to Employee</DialogTitle>
  <DialogContent>
    <Typography variant="body1" gutterBottom>
      Select an employee to assign this ticket.
    </Typography>
    <TextField
      select
      fullWidth
      label="Select Employee"
      value={selectedEmployeeId || ""}
      onChange={(e) => setSelectedEmployeeId(e.target.value)}
      SelectProps={{ native: true }}
      margin="normal"
    >
      <option value="" disabled>Select an employee</option>
      {employeeList.map((emp) => (
        <option key={emp.employeeId} value={emp.employeeId}>
          {emp.firstName} {emp.lastName}
        </option>
      ))}
    </TextField>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setAssignModalOpen(false)}>Cancel</Button>
    <Button variant="contained" onClick={handleAssignSubmit} disabled={!selectedEmployeeId}>
      Assign
    </Button>
  </DialogActions>
</Dialog>
     <Dialog open={showMessageModal} onClose={() => setShowMessageModal(false)} fullWidth maxWidth="sm">
      <DialogTitle>Messages</DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            maxHeight: "300px",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            paddingRight: 1,
          }}
        >
          {messageHistory.length === 0 ? (
            <Typography>No messages yet.</Typography>
          ) : (
            messageHistory.map((msg, idx) => (
              <Box
                key={idx}
                sx={{
                  alignSelf: msg.sender === "USER" ? "flex-start" : "flex-end",
                  backgroundColor: msg.sender === "USER" ? "#e2f0ff" : "#dcf8c6",
                  borderRadius: 2,
                  padding: 1,
                  maxWidth: "75%",
                }}
              >
                <Typography variant="body2">{msg.content}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {msg.sender} | {new Date(msg.timestamp).toLocaleString()}
                </Typography>
              </Box>
            ))
          )}
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ flexDirection: "column", alignItems: "stretch", gap: 1 }}>
        <TextField
          multiline
          minRows={2}
          placeholder="Type a message..."
          fullWidth
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="contained" onClick={handleSendMessage}>
            Send
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setShowMessageModal(false);
              setNewMessage("");
              setMessageHistory([]);
            }}
          >
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
    <>
    {loading && (
  <div className="fullpage_loader_overlay">
    <div className="fullpage_spinner" />
  </div>
)}

    <Modal open={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
  <Box className="ticket_modal_box">
    {selectedContact && (
      <>
      <div className="modal_header">
          <Typography variant="h6">Ticket Details</Typography>
          <CloseIcon
            onClick={() => setShowDetailsModal(false)}
            className="modal_close_icon"
            style={{ cursor: "pointer", float: "right" }}
          />
        </div>
        <div className="ticket_details_body">
          <div className="ticket_sections1">
            <div className="ticket_left_section1">
              <p><strong>ID:</strong> {selectedContact.id}</p>
              <p><strong>Email:</strong> {selectedContact.user?.email || selectedContact.email}</p>
              <p><strong>Subject:</strong> {selectedContact.subject}</p>
              <p><strong>Message:</strong> {selectedContact.message}</p>
              {selectedContact.fileNames && selectedContact.fileNames.length > 0 && (
                <div>
                  <p><strong>Uploaded Files:</strong></p>
                  <ul>
                    {selectedContact.fileNames.map((fileName, index) => (
                      <li key={index}>
                        <span
                          onClick={() => downloadFile(selectedContact.id, fileName)}
                          style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
                        >
                          {fileName}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}


            </div>

            <div className="ticket_right_section1">
              <p><strong>Submitted on:</strong> {new Date(selectedContact.createdDate).toLocaleString()}</p>

              {selectedContact.user && (
                <p><strong>solved?</strong> {
                  selectedContact.userConfirmedResolved === true
                    ? 'YES'
                    : selectedContact.userConfirmedResolved === false
                    ? 'NO'
                    : 'Not confirmed'
                }</p>
              )}

             {(["OPEN", "IN_PROGRESS", "REOPEN"].includes(selectedContact.status) ||
              (selectedContact.status === "SOLVED" && !selectedContact.user)) ? (

                  <select
                value={selectedContact.status}
                className={`status_dropdown ${
                  selectedContact.status === "OPEN"
                    ? "open_tab1"
                    : selectedContact.status === "IN_PROGRESS"
                    ? "pending_tab1"
                    : selectedContact.status === "REOPEN"
                    ? "reopened_tab1"
                    : ""
                }`}
                onChange={async (e) => {
                  const newStatus = e.target.value;
                  const prevStatus = selectedContact.status;

                  const allowedTransitions = {
                    OPEN: ["IN_PROGRESS"],
                    IN_PROGRESS: ["SOLVED"],
                    REOPEN: ["SOLVED"],
                    SOLVED: ["CLOSED"],
                  };


                  if (!allowedTransitions[prevStatus].includes(newStatus)) {
                    toast.warn(`Cannot move from ${prevStatus} to ${newStatus}`);
                    return;
                  }

                  if (newStatus === "CLOSED") {
                    setSelectedContactId(selectedContact.id);
                    setShowCloseModal(true);
                    return;
                  }
                  if (newStatus === "SOLVED" && !selectedContact.user) {
                  }
                  setLoading(true);
                  try {
                    await updateRequestStatus(selectedContact.id, newStatus);
                    toast.success(`Status changed from ${prevStatus} to ${newStatus}`);
                    const updatedRequests =
                      selectedTab === "registered"
                        ? await getRegisteredContactRequests()
                        : await getUnregisteredContactRequests();
                    setContactRequests(updatedRequests);
                    fetchCounts();
                    setShowDetailsModal(false);
                  } catch {
                    toast.error("Failed to update status.");
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                <option value={selectedContact.status} disabled>
                  {selectedContact.status === "SOLVED" ? "SOLVED" : selectedContact.status.replace("_", " ")}
                </option>
               {(() => {
                const allowedTransitions = {
                  OPEN: ["IN_PROGRESS"],
                  IN_PROGRESS: ["SOLVED"],
                  REOPEN: ["SOLVED"],
                  SOLVED: !selectedContact.user ? ["CLOSED"] : [],
                };
                return allowedTransitions[selectedContact.status]?.map((status) => (
                  <option key={status} value={status}>
                    {status === "SOLVED" ? "SOLVED" : status.replace("_", " ")}
                  </option>
                ));
              })()}

              </select>
            ) : (
              <select
                value={selectedContact.status}
                disabled
                className={`status_dropdown_no_arrow ${
                  selectedContact.status === "SOLVED"
                    ? "rejected_tab1"
                    : selectedContact.status === "CLOSED"
                    ? "closed_tab1"
                    : ""
                }`}
              >
                <option value={selectedContact.status}>
                  {selectedContact.status === "SOLVED" ? "SOLVED" : selectedContact.status.replace("_", " ")}
                </option>
              </select>
            )}


              {selectedContact.user && (
                <button onClick={() => handleOpenMessages(selectedContact.id)} className="message_button">
                  MESSAGE
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    )}
  </Box>
</Modal>
</>
    </>
  );
};
export default AdminDashboard;